import React from 'react';
import { Link } from 'react-router-dom';

function RegisterSuccessPage() {

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <svg
              className="mx-auto h-12 w-12 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h2 className="mt-3 text-2xl font-extrabold text-gray-900">
              Registration Successful!
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Your parking lot has been registered successfully!
            </p>

            <div className="mt-6 space-y-3">
              <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
                <p className="text-sm text-blue-800">
                  <strong>Next Steps:</strong> You can login with your email and password once your account is approved by an administrator.
                </p>
              </div>
              
              <div className="text-sm text-gray-600">
                <p>Your account is currently <span className="font-semibold text-yellow-600">pending approval</span>.</p>
                <p>Once approved by an admin, you'll be able to:</p>
                <ul className="mt-2 list-disc list-inside text-left">
                  <li>Access your dashboard</li>
                  <li>View your unique QR code</li>
                  <li>Start accepting payments</li>
                  <li>Track parking sessions</li>
                </ul>
              </div>
            </div>

            <div className="mt-6">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Go to Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterSuccessPage;